import { render, staticRenderFns } from "./CommunityExists.vue?vue&type=template&id=4cf8271b&"
import script from "./CommunityExists.vue?vue&type=script&lang=js&"
export * from "./CommunityExists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports